module.exports = __webpack_public_path__ + "img/contentImgHover7.cc83f52.png";